import {NEXT_REQUIRED_FIELDS} from './types';

export const extractErrorMessage = (error: unknown): string | null => {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'object' && error !== null) {
    const errorObj = error as Record<string, unknown>;

    if (errorObj.error && typeof errorObj.error === 'string') {
      return errorObj.error;
    }

    if (typeof errorObj.body === 'object' && errorObj.body !== null) {
      const body = errorObj.body as Record<string, unknown>;
      if (body.error && typeof body.error === 'string') {
        return body.error;
      }
    }

    if (errorObj.message && typeof errorObj.message === 'string') {
      return errorObj.message;
    }
  }

  return null;
};

export const extractNextRequiredField = (error: unknown): NEXT_REQUIRED_FIELDS | null => {
  if (typeof error === 'object' && error !== null) {
    const errorObj = error as Record<string, unknown>;

    if (
      errorObj.next_required_field &&
      typeof errorObj.next_required_field === 'string'
    ) {
      return errorObj.next_required_field as NEXT_REQUIRED_FIELDS;
    }

    if (typeof errorObj.body === 'object' && errorObj.body !== null) {
      const body = errorObj.body as Record<string, unknown>;
      if (body.next_required_field && typeof body.next_required_field === 'string') {
        return body.next_required_field as NEXT_REQUIRED_FIELDS;
      }
    }
  }

  return null;
};
